module.exports = __webpack_public_path__ + "img/cancontrol-capa.64f6319d.webp";